import {areWeTestingWithJest} from "@buildwithflux/shared";

import {getActiveServicesContainerSafelyFromRoot} from "./injection/singleton";

// Initialize document effect services eagerly so they are registered with the document store's
// service notification system. These services are lazily initialized by default, but they need
// to be created early so the store can notify them directly when actions are processed.
// Without this, the services would never be created and would never receive action notifications.
// Skip this in Jest tests to avoid Firebase client termination errors during test teardown.
if (!areWeTestingWithJest()) {
    const services = getActiveServicesContainerSafelyFromRoot();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    services.actionRecordService;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    services.documentSaveService;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    services.patchHandlerService;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    services.partNotificationService;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    services.documentConfigService;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    services.documentMetaSyncService;
}
